type BuildLiteNpsUploadPrefetchArgs = {
  hasPrimed: boolean;
  isLiteNpsEnabled: boolean;
  respondentId?: string | null;
  organizationID?: string | null;
  language?: string | null;
  triggerSource: string;
  startDateTime: string;
};

export type LiteNpsUploadPrefetchPlan = {
  questionnaireRequest: {
    language: string;
  };
  triggerRequest: {
    respondentId: string;
    organizationID: string;
    triggerSource: string;
    startDateTime: string;
  };
};

export const buildLiteNpsUploadPrefetchPlan = (
  args: BuildLiteNpsUploadPrefetchArgs
): LiteNpsUploadPrefetchPlan | null => {
  const { hasPrimed, isLiteNpsEnabled, respondentId, organizationID, language, triggerSource, startDateTime } = args;

  if (hasPrimed || !isLiteNpsEnabled || !respondentId || !organizationID) {
    return null;
  }

  return {
    questionnaireRequest: {
      language: language || 'en'
    },
    triggerRequest: {
      respondentId,
      organizationID,
      triggerSource,
      startDateTime
    }
  };
};
